<form [formGroup]="dataBaseForm" class="form-container row g-3">
    <div class="rowContainer col-12" *ngIf="configuration.hasName">
        <div class="col-2">
            <label for="name" class="label">{{configuration.name}}</label>
        </div>
        <div class="col-10">
            <input  data-testid="connection-name-input"
                    nbInput
                    type="text"
                    class="input form-control"
                    id="name"
                    formControlName="name">
        </div>
    </div>

    <div class="rowContainer col-12" *ngIf="configuration.hasConnectionList">
        <div class="col-2">
            <label for="name" class="label">نوع اتصال</label>
        </div>
        <div class="col-10 drop-down-design-setting">
            <ng-select class="design-setting-ng-select" bindLabel="name" bindValue="value"
                       [items]="dataBaseConnectionTypes"
                       formControlName="dbConnectionType"></ng-select>
        </div>
    </div>

    <div class="rowContainer col-12" *ngIf="configuration.hasConnectionKind">
        <div class="col-2">
            <label for="name" class="label">نوع اتصال</label>
        </div>
        <div class="col-10">
            <nb-radio-group class="d-flex" name="connection"
                            formControlName="connectionType" (valueChange)="changeConnectionType($event);connectionTypeChanges.emit($event)">
                <nb-radio data-testid="connection-type-radio" *ngFor="let type of connectionTypes"
                          [checked]="type.value === connectionType" [(value)]="type.value">{{type.name}}</nb-radio>
            </nb-radio-group>
        </div>
    </div>

    <div class="rowContainer col-12" *ngIf="configuration.hasConnectionType && connectionType === 'Selectable' && connections">
        <div class="col-2">
            <label for="name" class="label">اتصال</label>
        </div>
        <div class="col-10 drop-down-design-setting" [ngClass]="{'warning-ng-select': warning}">
            <ng-select data-testid="existed-connection" class="design-setting-ng-select" bindLabel="name" bindValue="id"
                       [items]="connections"
                       formControlName="selectedConnection" (change)="changeSelectedConnection($event)"></ng-select>
            <morva-linear-notifiction
                    *ngIf="warning"
                    [message]="'اتصال یافت نشد.'"
                    [messageType]="'warning'"
            >
            </morva-linear-notifiction>
        </div>
    </div>

    <div class="d-flex flex-wrap col-12" *ngIf="configuration.hasConnectionType && connectionType === 'Selectable'">
        <div class="col-2 align-self-start">
            <label for="name" class="label">انتخاب جدول</label>
        </div>
        <div class="col-10 tables-container" [nbSpinner]="loading">
            <div class="search-input mb-2">
                <input #searchKey fullWidth id="search-input" type="text" fieldSize="small" placeholder="جستجو"
                       (input)="searchTable(searchKey.value)" nbInput>
                <morva-icons icon="search" class="ms-2"></morva-icons>
            </div>
            <nb-radio-group *ngIf="showTables !== null; else tablesNotExist"
                            class="tables-list d-flex flex-column align-items-start custom-scroll"
                            name="connectionTables"
                            formControlName="selectedConnectionTable">
                <nb-radio data-testid="table-radio" class="label-overflow" [nbTooltip]="table.key" *ngFor="let table of showTables | keyvalue"
                          [(value)]="table.key">{{table.key}}</nb-radio>
            </nb-radio-group>
            <ng-template #tablesNotExist>
                <span class="not-selected-connection pt-2">ابتدا اتصال مربوطه را انتخاب کنید.</span>
            </ng-template>
        </div>

        <div class="col-12 align-self-start">
            <label class="label">تنظیمات بیشتر</label>
        </div>

        <div class="col-12" [style.display]="configuration.formType === 'EditSqlServer'?'none !important':'flex'">
            <nb-checkbox
                    status="basic"
                    class="checkbox form-control"
                    formControlName="hasRowLimited"
                    (checkedChange)="toggleRowLimited($event)">
                    در صورتی که جدول مبدا از تعداد ردیف مشخصی کمتر بود، {{configuration.formType === 'CreateSqlServer' ? 'بارگذاری': 'به‌روزرسانی'}} نشود.
            </nb-checkbox>
        </div>
        <div class="pe-4 d-flex col-12" [style.display]="configuration.formType === 'EditSqlServer'?'none !important':'flex'">
            <label for="rowLimit" class="label col-3">تعداد ردیف:</label>
            <input
                    nbInput
                    type="number"
                    class="w-25 input form-control"
                    id="rowLimit"
                    formControlName="numberOfRowLimited">
        </div>

        <div class="col-12">
            <nb-checkbox
                    status="basic"
                    class="checkbox form-control"
                    formControlName="hasTopN"
                    (checkedChange)="toggleTopN($event)">
                    تعداد ردیف مشخصی از کل ردیف‌های جدول مبدا {{configuration.formType === 'CreateSqlServer' ? 'بارگذاری': 'به‌روزرسانی'}} شود.
            </nb-checkbox>
        </div>
        <div class="pe-4 d-flex col-12">
            <label for="TopN" class="label col-3">تعداد ردیف بارگذاری:</label>
            <input
                    nbInput
                    disabled="true"
                    type="number"
                    class="w-25 input form-control"
                    id="TopN"
                    formControlName="numberOfTopN">
        </div>
    </div>


    <div class="rowContainer col-12" *ngIf="configuration.hasServer && connectionType === 'Queryable'">
        <div class="col-2">
            <label for="serverAddress" class="label">سرور</label>
        </div>
        <div class="col-6">
            <input  data-testid="server-address-input"
                    nbInput
                    type="text"
                    class="input form-control"
                    id="serverAddress"
                    formControlName="serverAddress">
        </div>
        <div class="col-1 me-auto">
            <label for="portNumber" class="label">پورت</label>
        </div>
        <div class="col-2">
            <input  data-testid="port-number-input"
                    nbInput
                    type="text"
                    class="input form-control"
                    id="portNumber"
                    formControlName="portNumber">
        </div>
    </div>

    <ng-template [ngIf]="!(configuration.formType === 'CreateOracle' || this.configuration.formType === 'EditOracle')">
        <div class="rowContainer col-12" *ngIf="configuration.hasServiceName && connectionType === 'Queryable'">
            <div class="col-2">
                <label for="dbName" class="label">{{configuration.serviceName}}</label>
            </div>
            <div class="col-10">
                <input
                data-testid="db-name-input"
                nbInput
                type="text"
                class="input form-control"
                id="dbName"
                formControlName="dbName">
            </div>
        </div>


        <div class="rowContainer col-12" *ngIf="configuration.hasWindowsAuthentication  && connectionType === 'Queryable'">
            <nb-checkbox
            status="basic"
                class="checkbox form-control"
                formControlName="windowsAuth"
                (checkedChange)="toggleWindowsAuth($event)">
                windows authentication
            </nb-checkbox>
        </div>
    </ng-template>

    <div class="rowContainer col-12" *ngIf="configuration.formType === 'CreateOracle' || this.configuration.formType === 'EditOracle'">
        <div class="col-2">
            <label for="serviceId" class="label">سرویس</label>
        </div>
        <div class="col-6">
            <input
                    nbInput
                    type="text"
                    class="input form-control"
                    id="serviceId"
                    formControlName="serviceIdentity"
                    placeholder="شناسه سرویس">
        </div>
        <div class="col-4 pe-2 drop-down-design-setting">
            <ng-select class="design-setting-ng-select" bindLabel="name" bindValue="value"
                       [items]="oracleConnectionTypes"
                       formControlName="oracleConnectionType"></ng-select>
        </div>
    </div>

    <div class="rowContainer col-12" *ngIf="configuration.hasUserAuthentication && connectionType === 'Queryable'">
        <div class="col-2">
            <label for="username" class="label">نام کاربری</label>
        </div>
        <div class="col-10">
            <input
                    data-testid="username-input"
                    nbInput
                    type="text"
                    class="input form-control"
                    id="username"
                    formControlName="username">
        </div>
    </div>


    <div class="rowContainer col-12" *ngIf="configuration.hasUserAuthentication && connectionType === 'Queryable'">
        <div class="col-2">
            <label for="password" class="label">گذرواژه</label>
        </div>
        <div class="col-10">
            <input
                    data-testid="password-input"
                    nbInput
                    autocomplete="new-password"
                    type="password"
                    class="input form-control"
                    id="password"
                    formControlName="password">
        </div>
    </div>


    <div class="rowContainer col-12" *ngIf="configuration.hasCommandTimeout && connectionType === 'Queryable'">
        <div class="col-5">
            <label for="commandTimeout" class="label">حد انتظار (Command timeout)</label>
        </div>
        <div class="col-7">
            <input
                    data-testid="command-timeout-input"
                    nbInput
                    type="number"
                    class="input form-control"
                    id="commandTimeout"
                    formControlName="commandTimeout"
                    placeholder="دقیقه">
        </div>
    </div>


    <div class="rowContainer flex-column align-items-start col-12" *ngIf="configuration.hasStatement && connectionType === 'Queryable'">
        <label for="connectionStatement" class="label mb-2 col-12">{{configuration.titleStatement}}</label>
        <div class="col-12">
          <textarea
                  data-testid="connection-statement-input"
                  nbInput
                  type="text"
                  class="input textarea form-control"
                  id="connectionStatement"
                  formControlName="connectionStatement"
                  rows="4"
          ></textarea>
        </div>
    </div>
</form>
